/**
 * Descripción: Gestor de Rutas de las vistas
 *
 * @displayName path
 */

import ErrorsRoutes from '@/views/Error/router';
import Dashboard from '@/views/Dashboard/router';
import About from '@/views/About/router';
import Blog from '@/views/Blog/router';

/**
 * Se obtienen rutas de las vistas
 */
const routes = [...About, ...Dashboard, ...ErrorsRoutes, ...Blog];

routes.forEach(filter);

/**
 * asignar lazyload y rutas hijas
 */
function filter(item) {
  if (item.component != undefined) {
    item.component = lazyLoad(item.component);
  }
  //recursiva
  if (item.children != undefined) {
    item.children.forEach(filter);
  }
}

/**
 * lazy load
 */
function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`);
}

export default routes;
